import authRoutesDefined from './auth';
import errorRoutesDefined from './error';
import mainRoutesDefined from './main';
import turnstileRouteDefined from './turnstile';

export const routesDefined = [
  turnstileRouteDefined,
  authRoutesDefined,
  errorRoutesDefined,
  mainRoutesDefined,
];
